export enum FormSectionType {
  CONTAINER,
  LINE_BREAK,
  PAGE_BREAK
}

export enum FormSectionItemType {
  FIELD,
  COLUMN_LAYOUT,
  LINE_BREAK
}
